import axios from 'axios'

axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Methods': '*',
  'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
  Accept: 'application/json',
  'Content-Type': 'application/json'
}

const clearLocalStorage = () => {
  localStorage.clear()
  window.location.href = ''
}

if (localStorage.getItem(process.env.VUE_APP_TOKEN)) {
  axios.defaults.headers.common.Authorization = 'Bearer ' + localStorage.getItem(process.env.VUE_APP_TOKEN)
  $.ajaxSetup({
    headers: {
      Accept: 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem(process.env.VUE_APP_TOKEN)
    }
  })
}

axios.interceptors.request.use(function (config) {
  return config
}, function (error) {
  return Promise.reject(error)
})

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response) {
    const { status } = error.response
    if (status) {
      if (status !== 401) {
        return Promise.reject(error)
      }
    }
  }
  return clearLocalStorage()
})

export default axios
